import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { D3LinePlot } from '../../common/D3LinePlot/D3LinePlot';
import { RainfallDischargeDataVM } from './RainfallDischargeDataVM';
import './rainfallDischargeData.scss';
import stores from 'cd-eft/models/Stores';
import { Checkbox } from 'cd-eft/components/common/Checkbox/Checkbox';

const RainfallDischargeDataComponent = (props) => {
  const vm = useRef(new RainfallDischargeDataVM(props)).current;

  React.useEffect(() => {
    if (stores.AppStore.efh2Store.rainfallPlotData) {
      const hasPlotData = stores.AppStore.efh2Store.rainfallPlotData['1-yr'];

      if (hasPlotData) {
        vm.rainfallPlotData = stores.AppStore.efh2Store.rainfallPlotData;
        vm.toggleSelectAll(true);
      } else {
        // clear plot
        vm.plotData = {};
      }
    }
  }, [stores.AppStore.efh2Store.rainfallPlotData]);

  React.useEffect(() => {
    // triggers validation when table updates
    if (stores.AppStore.efh2Store.rainfallDischargeTable.length) {
      vm.validateRainfallDischargeTable();
    }
  }, [stores.AppStore.efh2Store.rainfallDischargeTable]);

  React.useEffect(() => {
    if (stores.AppStore.efh2Store.rainfallPlotData) {
      const hasPlotData = stores.AppStore.efh2Store.rainfallPlotData['1-yr'];
      if (hasPlotData) {
        vm.rainfallPlotData = stores.AppStore.efh2Store.rainfallPlotData;
        vm.toggleSelectAll(true);
      }
    }
  }, []);

  return (
    <div>
      <div className="grid-row">
        <div className="tablet:grid-col-6 rdd-column">
          <table className="usa-table usa-table--borderless usa-table--stacked table-mobile">
            <thead className="theader">
              <tr>
                <th scope="col">
                  <div className="usa-checkbox select-all-rows">
                    <input
                      className="usa-checkbox__input"
                      id="selectAll"
                      aria-label="Select all storm numbers."
                      data-behavior="select-table-row"
                      type="checkbox"
                      name="selectAll"
                      value="selectAll"
                      checked={vm.selectAllHydrographs}
                      onChange={() => {
                        vm.toggleSelectAll(!vm.selectAllHydrographs);
                      }}
                    />
                    <label className="usa-checkbox__label" htmlFor="selectAll"></label>
                  </div>

                  <span className="table-header">Frequency (yr)</span>

                </th>

                <th scope="col">
                  <span className="table-header">24-HR Rain (in)</span>
                </th>
                <th scope="col">
                  <span className="table-header">Peak Flow (cfs)</span>
                </th>
                <th scope="col">
                  <span className="table-header">Runoff (in)</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {stores.AppStore.efh2Store.rainfallDischargeTable.map((item, i) => {
                return (
                  <tr id={'row' + i} key={'key' + i} className="tr">
                    <td className="storm-col" aria-label="frequency">
                      <Checkbox
                        label={item.frequency}
                        id={'selected' + i}
                        checked={item.selected}
                        name="selected"
                        onChange={(event) => {
                          const target = event.target;
                          const value = target.checked;
                          vm.handleCheckboxChange(event);
                          vm.selectHydrograph(i, value);
                        }}
                      />


                      <span className="usa-error-message" id={'frequency--message' + i} role="alert">
                        {vm.formValidation.formErrors.frequency[i]}
                      </span>
                    </td>
                    <td className="" aria-label="30-Day Period PCP">
                      <span className="table-header tbheader-mobile">24-HR Rain (in)</span>
                      <input
                        className={
                          vm.formValidation.formErrors.rainfall[i] ? 'usa-input usa-input--error' : 'usa-input'
                        }
                        id={'rainfall' + i}
                        aria-label="24 hour rainfall in inches"
                        aria-describedby={'rainfall--message' + i}
                        aria-readonly="true"
                        name="rainfall"
                        type="number"
                        value={item.rainfall ? item.rainfall.toFixed(2) : '--'}
                        readOnly={true}
                      />
                      <span className="usa-error-message" id={'rainfall--message' + i} role="alert">
                        {vm.formValidation.formErrors.rainfall[i]}
                      </span>
                    </td>
                    <td className="" aria-label="Peak Flow">
                      <span className="table-header tbheader-mobile">Peak Flow (cfs)</span>
                      <input
                        className={
                          vm.formValidation.formErrors.peakFlow[i] ? 'usa-input usa-input--error' : 'usa-input'
                        }
                        id={'peakFlow' + i}
                        aria-label="peak flow rate in cubic feet per second"
                        aria-describedby={'peakFlow--message' + i}
                        aria-readonly="true"
                        name="peakFlow"
                        type="number"
                        value={item.peakFlow ? item.peakFlow.toFixed(2) : '--'}
                        readOnly={true}
                      />
                      <span className="usa-error-message" id={'peakFlow--message' + i} role="alert">
                        {vm.formValidation.formErrors.peakFlow[i]}
                      </span>
                    </td>
                    <td className="" aria-label="Runoff">
                      <span className="table-header tbheader-mobile">Runoff (in)</span>
                      <input
                        className={vm.formValidation.formErrors.runoff[i] ? 'usa-input usa-input--error' : 'usa-input'}
                        id={'runoff' + i}
                        aria-label="runoff in inches"
                        aria-describedby={'runoff--message' + i}
                        aria-readonly="true"
                        name="runoff"
                        type="number"
                        value={item.runoff ? item.runoff.toFixed(2) : '--'}
                        readOnly={true}
                      />
                      <span className="usa-error-message" id={'runoff--message' + i} role="alert">
                        {vm.formValidation.formErrors.runoff[i]}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="tablet:grid-col-6 hydrograph-container rdd-column">
          <h3 className="h3-center">Hydrograph</h3>
          <D3LinePlot targetDivID={vm.targetDivID} windowOptions={vm.windowOptions} plotData={vm.plotData} />
        </div>
      </div>
    </div>
  );
};

export const RainfallDischargeData = observer(RainfallDischargeDataComponent);
